// Only the aggregate count is held in memory. Read cursors belong to the server.
const CommunityUnread = {
    _request: 0,
    total: 0,
    _unavailable: false,
    _known: null, // {epoch, estado} of the last successful count
    reset() {
        ++this._request;
        this._known = null;
        this.total = 0;
        this.render();
    },
    render(unavailable = false) {
        const button = document.getElementById('header-community-btn');
        const badge = document.getElementById('header-community-badge');
        if (!button || !badge) return;
        const count = this.total;
        badge.textContent = count > 99 ? '99+' : count ? String(count) : '';
        badge.classList.toggle('has-count', count > 0);
        badge.style.display = count > 0 ? 'flex' : 'none';
        const name = SchoolService.label('Comunidad');
        const label = unavailable ? `${name}: no se pudo actualizar el contador` :
            count ? `${name}: ${count} ${count === 1 ? 'mensaje nuevo' : 'mensajes nuevos'}` : name;
        button.title = label;
        button.setAttribute('aria-label', label);
    },
    async refresh() {
        if (!AuthManager.isLoggedIn()) { this.reset(); return; }
        const request = ++this._request, epoch = AuthManager._epoch, token = AuthManager.getCsrfToken();
        const current = () => request === this._request && epoch === AuthManager._epoch && token === AuthManager.getCsrfToken() && AuthManager.isLoggedIn();
        try {
            const response = await fetch('/api/comunidad/no-leidos', {cache:'no-store'});
            const result = await response.json();
            if (!current()) return;
            if (!response.ok || !result.success || !Number.isSafeInteger(result.total) || result.total < 0) throw new Error('Contador no disponible');
            this.total = result.total;
            this._unavailable = false;
            this.render();
        } catch {
            if (current()) { this.total = 0; this._unavailable = true; this.render(true); }
        }
    },
    // Cheap server fingerprint of Comunidad for this user (null when unavailable).
    async fetchEstado() {
        try {
            const response = await fetch('/api/comunidad/estado', {cache:'no-store'});
            const result = await response.json();
            return response.ok && result.success && typeof result.estado === 'string' ? result.estado : null;
        } catch { return null; }
    },
    // Background polling: only recount when Comunidad changed for this user.
    async refreshIfChanged() {
        if (!AuthManager.isLoggedIn()) { this.reset(); return; }
        const epoch = AuthManager._epoch, estado = await this.fetchEstado();
        if (estado && this._known && this._known.epoch === epoch && this._known.estado === estado) return;
        await this.refresh();
        if (estado && !this._unavailable && epoch === AuthManager._epoch) this._known = {epoch, estado};
    }
};
window.CommunityUnread = CommunityUnread;
